import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { pinia } from '@v2/legacy-bridge/services/stores';

/* UI Kit - loaded first so Tailwind can override */
import 'uikit/dist/css/uikit.css';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);
// Configure global container for all teleported UIKit components (modals, dropdowns, tooltips)
(UIkit as any).container = '#uk-modal-container';

/* Tailwind CSS - loaded after UIkit to take priority */
import '@v2/assets/tailwind.css';

/* Primevue 4 */
import 'primeicons/primeicons.css';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

/* Vue Meta / Unhead */
import { createHead } from '@unhead/vue/client';

/* Legacy Bootstrap - registers Vuex, global components, legacy singletons, legacy styles */
import { bootstrapLegacy } from '@v2/legacy-bridge/bootstrap';

/* Create Vue 3 App */
const app = createApp(App);

// v2-native plugins
app.use(router);
app.use(pinia);
app.use(createHead());
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark-mode',
    },
  },
});

// Legacy support - registers Vuex store, global components, etc.
bootstrapLegacy(app);

// Development Configuration
if (import.meta.env.DEV) {
  app.config.performance = true;
}

app.mount('#app');
